// extracted by mini-css-extract-plugin
module.exports = {"messages":"MessageList_messages__2a7ro","noPadding":"MessageList_noPadding__1fh9M"};